import {ApiClient} from '@hconnect/apiclient'
import {DateRange} from '@hconnect/uikit/src/common'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useEffect} from 'react'

import {EQUIPMENT_KPI_REQUEST_STALE_TIME} from '../../consts'
import {mapDateRangeToQuery} from '../../mappers'
import {EquipmentKpiStatsDto, KpisQueryKey} from '../../types'

type Options<TSelect> = Omit<
  UseQueryOptions<EquipmentKpiStatsDto | null, AxiosError, TSelect>,
  'queryKey' | 'queryFn'
> & {
  onError?: (error: AxiosError) => void
}

const QueryKeyPrefix = KpisQueryKey.EquipmentKilnKpisYtmStats

export const useEquipmentKilnKpisYtmStats = <TSelect = EquipmentKpiStatsDto | null>(
  plantId: string,
  dateRange: DateRange<Date>,
  options?: Options<TSelect>
) => {
  const query = useQuery<EquipmentKpiStatsDto | null, AxiosError, TSelect>({
    queryKey: [QueryKeyPrefix, dateRange, plantId],
    queryFn: async ({signal}) => {
      const response = await ApiClient.axiosInstance.get<EquipmentKpiStatsDto>(
        `/kpi-result/${plantId}/cockpit-ytm`,
        {
          params: {
            ...mapDateRangeToQuery(dateRange)
          },
          signal
        }
      )

      return response.data
    },
    staleTime: EQUIPMENT_KPI_REQUEST_STALE_TIME,
    ...options
  })

  const onError = options?.onError

  useEffect(() => {
    if (query.error) {
      onError?.(query.error)
    }
  }, [query.error, onError])

  return query
}